import React from 'react';
import { NOTIFICATION_INFO } from '../store/Constants';
import StoreListener from '../store/StoreListener';

const storeItems = [NOTIFICATION_INFO];
@StoreListener(storeItems)
export default class NotificationIcon extends React.Component {
  state = {
    count: 0
  };

  componentDidUpdate() {
    const allActivitiesSelected =
      !window.gs.notificationInfo.onlyTasks && !window.gs.notificationInfo.onlyNotifications;
    if (this.noNewNotifications() && this.state.showNotification && allActivitiesSelected) {
      this.setState({ showNotification: false });
    }
  }

  getNotificationsCount = () => {
    return this.props.unreadCommentCount;
  };

  noNewNotifications = () => {
    return this.getNotificationsCount() === 0;
  };

  updateNotificationCount = () => {
    this.setState({ count: count + 1 });
  };

  render() {
    const { styles } = this.props;
    const noNewNotifications = this.noNewNotifications();
    const allActivitiesSelected =
      !window.gs.notificationInfo.onlyTasks && !window.gs.notificationInfo.onlyNotifications;
    if (noNewNotifications && allActivitiesSelected) {
      return null;
    }
    return (
      <div id="NotificationBell" style={styles.notificationIcon} onClick={this.props.toggleShowNotificationState}>
        <span style={styles.notificationCount}>{this.getNotificationsCount()}</span>
      </div>
    );
  }
}
